export const REVIEW_CYCLES_STATUS_PUBLISHED = 'published';
export const REVIEW_CYCLES_STATUS_DRAFT = 'draft';
